import { Directive, AfterViewChecked, ElementRef, DoCheck } from '@angular/core';

@Directive({
    selector: '[myFocus]',
    standalone: false
})
export class FocusDirective implements AfterViewChecked, DoCheck {
    private lastVisible: boolean = false;
    private initialised: boolean = false;

    constructor(private el: ElementRef) { }

    ngAfterViewChecked() {
        //console.log('inside FocusDirective.ngAfterViewChecked()');
        this.initialised = true;
        this.ngDoCheck();
    }

    ngDoCheck() {
        //console.log('inside FocusDirective.ngDoCheck()');

        if (!this.initialised) {
            return;
        }
        const visible = !!this.el.nativeElement.offsetParent;
        if (visible && !this.lastVisible) {
            setTimeout(() => {
                this.el.nativeElement.focus();
            }, 1);
        }
        this.lastVisible = visible;
    }
}
